import { Outlet, useParams } from 'react-router-dom'
import DashHeader from './DashHeader'
import DashFooter from './DashFooter'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { changeArchiveState, selectArchive } from '../features/settings/archiveSlice'
import { apiSlice } from '../app/api/apiSlice'

const DashLayout = () => {
    const {type} = useParams()
    const dispatch = useDispatch()
    const {archive} = useSelector(selectArchive)

    useEffect(()=>{
       
        if(type === "archive" && !archive){
            console.log("archive-change")
            dispatch(changeArchiveState(true))
            setTimeout(() => {
                dispatch(apiSlice.util.resetApiState())
            }, 1000)
        }
        else if(type !== "archive" && archive){
            dispatch(changeArchiveState(false))
            setTimeout(() => {
                dispatch(apiSlice.util.resetApiState())
            }, 1000)
        }
      
       
    },[type])
    return (
        <>
            <DashHeader />
            <div className="dash-container">
                <Outlet />
            </div>
            <DashFooter />
        </>
    )
}
export default DashLayout